import { NgModule } from '@angular/core';
import { SlugifyPipe } from './slugify.pipe';

@NgModule({
  imports: [],
  declarations: [SlugifyPipe],
  exports: [SlugifyPipe],
  providers: [],
})
export class PipesModule {}
